import { useCommunityId } from '@/hooks/communities';
import { useUnits } from '@/hooks/units';
import FloorPlansPage from '@/pages/FloorPlansPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/floor-plans')({
  component: FloorPlansPage,
  loader: async ({ context: { queryClient } }) => {
    const data = await useCommunityId.ensureQueryData(queryClient);
    if (data?.communityId) {
      await useUnits.ensureQueryData(queryClient, [data.communityId]);
    }
  },
});
